module.exports = __webpack_public_path__ + "static/img/logo.0af0d73e.png";